// extracted by mini-css-extract-plugin
export default {"ldsDualRing":"loading_ldsDualRing__zQa4M","lds-dual-ring":"loading_lds-dual-ring__FyvOa"};